import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import cloneDeep from 'lodash/cloneDeep'
import isNil from 'lodash/isNil'
import { Modal, Table, Button, InputNumber, message } from 'hljd'
// import columns from './columns'
import Style from './index.module.less'

@observer
export default class extends Component {
  columns = [
    {
      title: '名称',
      dataIndex: 'title',
      width: 144,
      align: 'left'
    },
    {
      title: '封面图',
      dataIndex: 'cover_path',
      align: 'center',
      width: 50,
      render: cover_path => (
        <div className={Style.img}>
          <img src={cover_path + '?imageView2/2/w/122'} />
        </div>
      )
    },
    {
      title: '价格',
      dataIndex: 'actual_price',
      align: 'left',
      width: 80,
      render: (actual_price, { earnest_money }) => (
        <div>
          <div>现价￥{actual_price}</div>
          <div>定金￥{earnest_money}</div>
        </div>
      )
    },
    {
      title: '活动价',
      dataIndex: 'activity_price',
      align: 'center',
      width: 50,
      render: (activity_price, { id }) => (
        <div>
          <InputNumber
            value={activity_price}
            onChange={e => this.onActivityPriceChange(e, id)}
            style={{ width: 70 }}
            min={0}
            max={9999999}
          />
          <span style={{ marginLeft: 8 }}>元</span>
        </div>
      )
    }
  ]

  state = {
    packageList: []
  }

  componentDidMount() {
    const { packageList } = this.props.store
    this.setState({
      packageList: cloneDeep(toJS(packageList))
    })
  }

  onSelectChange = selectedRowKeys => {
    console.log('selectedRowKeys changed: ', selectedRowKeys)
    this.state.packageList.forEach(
      (p, index) => (p.checked = selectedRowKeys.includes(index))
    )
    this.setState({
      packageList: this.state.packageList
    })
  }

  onActivityPriceChange = (price, id) => {
    console.log('activityPriceChange:', price, id)
    const packaged = this.state.packageList.find(l => l.id === id)
    packaged.activity_price = price

    this.setState({
      packageList: this.state.packageList
    })
  }

  handleModalOk = () => {
    const { packageList } = this.state
    const { savePackage } = this.props.store

    if (packageList.filter(p => p.checked).length > 8) {
      message.warning('最多选择8个套餐')
      return
    }
    if (packageList.some(p => p.checked && isNil(p.activity_price))) {
      message.warning('勾选的套餐，需要输入活动价')
      return
    }

    savePackage(packageList)
  }

  render() {
    const { packageList } = this.state
    const { closePackageModal } = this.props.store
    const selectedRowKeys = []
    packageList.forEach((p, index) => p.checked && selectedRowKeys.push(index))

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      columnTitle: '选择'
    }

    return (
      <Modal
        title={
          <p>
            <span style={{ fontWeight: 'bold', fontSize: 14 }}>选择套餐</span>
          </p>
        }
        visible={true}
        width={780}
        height={600}
        centered={true}
        onCancel={closePackageModal}
        onOk={this.handleModalOk}
        footer={
          <div className={Style.footer}>
            <div className={Style.text}>
              已选择
              <span style={{ color: '#448AFC' }}>
                {rowSelection.selectedRowKeys.length}
              </span>
              个套餐，最多可选8个套餐
            </div>
            <div>
              <Button className={Style.btn} onClick={closePackageModal}>
                取消
              </Button>
              <Button
                className={Style.btn}
                type="primary"
                onClick={this.handleModalOk}
              >
                确定
              </Button>
            </div>
          </div>
        }
      >
        <div className={Style.tableBox}>
          <Table
            className={Style.table}
            pagination={false}
            rowSelection={rowSelection}
            columns={this.columns}
            dataSource={packageList}
          />
        </div>
      </Modal>
    )
  }
}
